import { render, staticRenderFns } from "./AssessmentBatch.vue?vue&type=template&id=211baf42"
import script from "./AssessmentBatch.vue?vue&type=script&lang=js"
export * from "./AssessmentBatch.vue?vue&type=script&lang=js"
import style0 from "./AssessmentBatch.vue?vue&type=style&index=0&id=211baf42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports